module.exports = __webpack_public_path__ + "img/Menor_tempo_de_emissao.40cecf8.svg";